module.exports = __webpack_public_path__ + "assets/img/advantage_01.465d7c02.png";